(function () {
  var api = window.NCGallerySimpleGrid || {};
  var previousBodyOverflow = "";
  var openRoot = null;

  function parseItems(root) {
    var dataScript = root.querySelector("[data-nc-gallery-data]");
    if (!dataScript) return [];

    try {
      return JSON.parse(dataScript.textContent || "[]");
    } catch (error) {
      return [];
    }
  }

  function setBodyLocked(isLocked) {
    if (isLocked) {
      if (!openRoot) {
        previousBodyOverflow = document.body.style.overflow;
      }
      document.body.style.overflow = "hidden";
      return;
    }

    document.body.style.overflow = previousBodyOverflow;
    previousBodyOverflow = "";
  }

  function renderLightbox(root, index) {
    var state = root.ncGallerySimpleGridState;
    var item = state.items[index];
    var media = root.querySelector("[data-nc-gallery-lightbox-media]");
    var caption = root.querySelector("[data-nc-gallery-lightbox-caption]");
    var title = root.querySelector("[data-nc-gallery-lightbox-title]");
    var description = root.querySelector("[data-nc-gallery-lightbox-description]");
    var lightbox = root.querySelector("[data-nc-gallery-lightbox]");

    if (!item || !media || !caption || !title || !description || !lightbox) return;

    media.textContent = "";

    if (item.hasImage && item.image) {
      var image = document.createElement("img");
      image.src = item.image;
      image.alt = item.alt || "";
      image.loading = "eager";
      image.decoding = "async";
      media.appendChild(image);
    } else {
      var placeholder = document.createElement("div");
      placeholder.className = "nc-gallery-simple-grid__lightbox-placeholder";
      placeholder.setAttribute("aria-hidden", "true");
      media.appendChild(placeholder);
    }

    title.textContent = item.title || "";
    description.textContent = item.description || "";
    title.hidden = !item.title;
    description.hidden = !item.description;
    caption.hidden = !item.hasCaption;
    lightbox.setAttribute("aria-label", item.title || item.alt || "Gallery image preview");
  }

  function openLightbox(root, index) {
    var state = root.ncGallerySimpleGridState;
    var lightbox = root.querySelector("[data-nc-gallery-lightbox]");

    if (!state || !lightbox || !state.items.length) return;

    state.activeIndex = (index + state.items.length) % state.items.length;
    renderLightbox(root, state.activeIndex);
    lightbox.hidden = false;
    openRoot = root;
    setBodyLocked(true);

    var closeButton = root.querySelector("[data-nc-gallery-close]");
    if (closeButton) closeButton.focus();
  }

  function closeLightbox(root) {
    var state = root && root.ncGallerySimpleGridState;
    var lightbox = root && root.querySelector("[data-nc-gallery-lightbox]");

    if (!state || !lightbox) return;

    lightbox.hidden = true;
    state.activeIndex = null;

    if (openRoot === root) {
      openRoot = null;
      setBodyLocked(false);
    }

    if (state.lastTrigger && document.contains(state.lastTrigger)) {
      state.lastTrigger.focus();
    }
  }

  function moveLightbox(root, direction) {
    var state = root.ncGallerySimpleGridState;
    if (!state || state.activeIndex === null || !state.items.length) return;

    state.activeIndex = (state.activeIndex + direction + state.items.length) % state.items.length;
    renderLightbox(root, state.activeIndex);
  }

  function resetRoot(root) {
    var state = root && root.ncGallerySimpleGridState;
    if (!state) return;

    closeLightbox(root);

    state.triggers.forEach(function (trigger) {
      trigger.removeEventListener("click", state.handlers.triggerClick);
    });

    if (state.lightbox) {
      state.lightbox.removeEventListener("click", state.handlers.lightboxClick);
    }

    if (state.content) {
      state.content.removeEventListener("click", state.handlers.contentClick);
    }

    if (state.closeButton) {
      state.closeButton.removeEventListener("click", state.handlers.closeClick);
    }

    if (state.prevButton) {
      state.prevButton.removeEventListener("click", state.handlers.prevClick);
    }

    if (state.nextButton) {
      state.nextButton.removeEventListener("click", state.handlers.nextClick);
    }

    document.removeEventListener("keydown", state.handlers.keydown);
    delete root.ncGallerySimpleGridState;
    delete root.dataset.ncGallerySimpleGridInitialized;
  }

  function initRoot(root) {
    if (!root || root.dataset.ncGallerySimpleGridInitialized === "true") return;

    var items = parseItems(root);
    var triggers = Array.prototype.slice.call(root.querySelectorAll("[data-nc-gallery-item]"));
    var lightbox = root.querySelector("[data-nc-gallery-lightbox]");
    var content = root.querySelector("[data-nc-gallery-lightbox-content]");
    var closeButton = root.querySelector("[data-nc-gallery-close]");
    var prevButton = root.querySelector("[data-nc-gallery-prev]");
    var nextButton = root.querySelector("[data-nc-gallery-next]");

    if (!items.length || !triggers.length || !lightbox) return;

    var state = {
      items: items,
      triggers: triggers,
      lightbox: lightbox,
      content: content,
      closeButton: closeButton,
      prevButton: prevButton,
      nextButton: nextButton,
      activeIndex: null,
      lastTrigger: null,
      handlers: {}
    };

    state.handlers.triggerClick = function (event) {
      var trigger = event.currentTarget;
      var index = parseInt(trigger.getAttribute("data-nc-gallery-index") || "0", 10);
      state.lastTrigger = trigger;
      openLightbox(root, index);
    };

    state.handlers.lightboxClick = function () {
      closeLightbox(root);
    };

    state.handlers.contentClick = function (event) {
      event.stopPropagation();
    };

    state.handlers.closeClick = function (event) {
      event.stopPropagation();
      closeLightbox(root);
    };

    state.handlers.prevClick = function (event) {
      event.stopPropagation();
      moveLightbox(root, -1);
    };

    state.handlers.nextClick = function (event) {
      event.stopPropagation();
      moveLightbox(root, 1);
    };

    state.handlers.keydown = function (event) {
      if (state.activeIndex === null) return;

      if (event.key === "Escape") {
        closeLightbox(root);
      }

      if (event.key === "ArrowLeft") {
        moveLightbox(root, -1);
      }

      if (event.key === "ArrowRight") {
        moveLightbox(root, 1);
      }
    };

    triggers.forEach(function (trigger) {
      trigger.addEventListener("click", state.handlers.triggerClick);
    });

    lightbox.addEventListener("click", state.handlers.lightboxClick);
    if (content) content.addEventListener("click", state.handlers.contentClick);
    if (closeButton) closeButton.addEventListener("click", state.handlers.closeClick);
    if (prevButton) prevButton.addEventListener("click", state.handlers.prevClick);
    if (nextButton) nextButton.addEventListener("click", state.handlers.nextClick);
    document.addEventListener("keydown", state.handlers.keydown);

    root.ncGallerySimpleGridState = state;
    root.dataset.ncGallerySimpleGridInitialized = "true";
  }

  function initAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll
      ? scope.querySelectorAll("[data-nc-gallery-simple-grid]")
      : [];

    if (scope.matches && scope.matches("[data-nc-gallery-simple-grid]")) {
      initRoot(scope);
    }

    roots.forEach(initRoot);
  }

  function resetAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll
      ? scope.querySelectorAll("[data-nc-gallery-simple-grid]")
      : [];

    if (scope.matches && scope.matches("[data-nc-gallery-simple-grid]")) {
      resetRoot(scope);
    }

    roots.forEach(resetRoot);
  }

  api.initAll = initAll;
  api.resetAll = resetAll;
  window.NCGallerySimpleGrid = api;

  if (!window.__ncGallerySimpleGridEventsBound) {
    window.__ncGallerySimpleGridEventsBound = true;

    document.addEventListener("DOMContentLoaded", function () {
      window.NCGallerySimpleGrid.initAll(document);
    });

    document.addEventListener("shopify:section:load", function () {
      window.NCGallerySimpleGrid.resetAll(document);
      window.NCGallerySimpleGrid.initAll(document);
    });

    document.addEventListener("shopify:section:unload", function (event) {
      window.NCGallerySimpleGrid.resetAll(event.target);
    });
  }

  if (document.readyState !== "loading") {
    window.NCGallerySimpleGrid.initAll(document);
  }
})();
